import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import Pms_FbRo from "../rv/fb/rvo";
import {withRouter} from "../../lib/react/withRouter";
import sso from "../../sso";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Pms_Fo extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.paa = [];
    this.state.aa = [];
    this.state.wnds = {};

    this.state.mna = [];
    this.state.mna.push({ mnid: "mn01", pos: "c1", text: "NY BOKNING", desc: "Skapa ny bokning", link: "/pms/fo/rvn" });
    this.state.mna.push({ mnid: "mn02", pos: "c1", text: "PRELIMINÄRA", desc: "Preliminära bokningar", link: "/pms/fo/rvp" });
    this.state.mna.push({ mnid: "mn03", pos: "c1", text: "SENAST BOKAT", desc: "Bokningar senast först", link: "/pms/fo/rvl" });
    this.state.mna.push({ mnid: "mn04", pos: "c1", text: "SÖK", desc: "Sök bokning/gäst/kund", link: "/pms/fo/sz" });
    this.state.mna.push({ mnid: "mn05", pos: "c2", text: "KUNDER", desc: "Kundregister", link: "/pms/fo/kreg" });
    this.state.mna.push({ mnid: "mn06", pos: "c2", text: "AKTIVITETSSKÄRM", desc: "Aktiviteter under period", link: "/pms/fo/acs" });
    this.state.mna.push({ mnid: "mn07", pos: "c2", text: "MALLAR", desc: "Bekräftelse mallar", link: "/pms/fo/tmpl" });
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
  }
    mnc(pos) {
        var mna = [];
        for(var row of this.state.mna) {
            if(row.pos == pos) mna.push( row );
        }
        return mna;
    }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 480;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  rvn_open() {
      var self = this;
      var wnds = {};
      wnds.rvn = 1;
    this.setState({ wnds: wnds });
  }
  fknGo(url) {
    //alert(row.href);
      if(url == "/pms/fo/rvn") {
          this.rvn_open();
          return;
      }
    var row = {};
    row.url = url;
    sso.seo.sfkn = row;
    this.props.navigate(url);
  }

  render() {
    return (
    <div className="web-app">
        <div className="web-pg py-4 flex">
            <h3>Frontoffice</h3>
            <p>Frontoffice funktioner</p>

            <div className="divider_green"></div>

            <div className="web-row">
                <div className="flex-col flex">
                    { this.mnc("c1").map((row, key) =>
                        <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex-col flex">
                    { this.mnc("c2").map((row, key) =>
                        <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>

            { this.state.wnds.rvn ?
        <Pms_FbRo show={this.state.wnds.rvn} ctx={this} store={this.props.store} backdrop={true}/>
            : null }
    </div>
  );
    }
}
export default withRouter(Pms_Fo);
